// Client
import React, { useState } from "react";
import {
  getChallengeFromServer,
  getCredentialIdBuffer,
  toServerVerifySecondLogin,
} from "./Server";
import { styles } from "./styles";

const SecondLogin = ({ email }) => {
  const [stage, setStage] = useState("bioAuth");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const getBiometricsCredentials = async () => {
    // Check for WebAuthn support
    if (!window.PublicKeyCredential) {
      alert("Biometric authentication is not supported by this browser.");
      return;
    }

    try {
      const challenge = getChallengeFromServer(email);

      const credentialIdBuffer = getCredentialIdBuffer(email);

      const publicKey = {
        challenge,
        allowCredentials: [
          {
            type: "public-key",
            id: credentialIdBuffer,
            transports: ["internal"],
          },
        ],
        userVerification: "required",
      };

      const credential = await navigator.credentials.get({ publicKey });

      console.log("foo: credential: ", credential);

      await toServerVerifySecondLogin(email, credential);

      setShowSuccessMessage(true);

      setTimeout(() => {
        setStage("bank");
        setShowSuccessMessage(false); // Hide the success message
      }, 2000);

      setStage("bank");
    } catch (err) {
      console.error("Error during biometric registration:", err);
      alert("Failed to enable biometric authentication." + err);
    }
  };

  if (showSuccessMessage) {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          Biometric authentication enabled successfully.
        </h1>
        <div style={styles.checkmark}>
          &#x2714; {/* Unicode character for checkmark */}
        </div>
      </div>
    );
  }

  let subject;

  if (stage === "bioAuth") {
    subject = "Congratz! You have enabled super fast login!";
  } else if (stage === "bank") {
    subject = "Choose account";
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>{subject}</h1>
      {stage === "bioAuth" && (
        <button onClick={getBiometricsCredentials} style={styles.button}>
          Get Biometric Authentication
        </button>
      )}

      {stage === "bank" && (
        <div style={{ ...styles.form, alignItems: "flex-start" }}>
          <div style={styles.bankAccount}>Bank account 1</div>
          <div style={styles.bankAccount}>Bank account 2</div>
        </div>
      )}
    </div>
  );
};

export default SecondLogin;
